import { RCNEndOfYearSummary } from './RCNEndOfYearSummary'
import { ISDEndOfYearSummary } from './ISDEndOfYearSummary'
import { SurveyPdfReportShell } from '../../MidYear/Summary/SurveyPdfReportShell'
import { type SurveySchema, SurveyType } from '../../../../../../models/SurveySchema'
import { type SurveyContent } from '../../MidYear/Summary/MidYearSummary'

export const EndOfYearSummary = ({ initialSurvey }: { initialSurvey: SurveySchema }): JSX.Element => {
  const content: SurveyContent = JSON.parse(initialSurvey.content)
  const answers: Record<string, any> = initialSurvey.answers != null ? JSON.parse(initialSurvey.answers) : {}

  if (content == null) return <div>No End of Year Summary found</div>

  return (
    <SurveyPdfReportShell
      title='End of Year Progress Report Submission'
      pdfElementId='eoy-summary-pdf'
      cardTestId='endOfYearSummaryCard'
    >
      {(forceExpanded) => (
        initialSurvey.id === SurveyType.RCNEndOfYear
          ? <RCNEndOfYearSummary content={content} answers={answers} />
          : <ISDEndOfYearSummary content={content} answers={answers} forceExpanded={forceExpanded} />
      )}
    </SurveyPdfReportShell>
  )
}
